import { capitalizeFirstLetter } from './string';
import { MEDICAL_CERTIFICATE_REASON_OPTIONS } from '../contants/medicalCertificateReasons';

export function reconstructCertificateReasonFromText(texto: string): string {
  const capitalized = capitalizeFirstLetter(texto);
  if (Object.values(MEDICAL_CERTIFICATE_REASON_OPTIONS).includes(capitalized)) {
    return capitalized;
  }
  if (texto.includes(MEDICAL_CERTIFICATE_REASON_OPTIONS.ORIENTED_TO_REST_TODAY)) {
    return MEDICAL_CERTIFICATE_REASON_OPTIONS.ORIENTED_TO_REST_TODAY;
  }
  const restForPeriodPrefix = MEDICAL_CERTIFICATE_REASON_OPTIONS.ORIENTED_TO_REST_FOR_PERIOD.split('hoje')[0] + 'hoje';
  if (texto.includes(restForPeriodPrefix)) {
    return MEDICAL_CERTIFICATE_REASON_OPTIONS.ORIENTED_TO_REST_FOR_PERIOD;
  }
  return texto;
}

export function cleanCertificateReason(texto: string, isFreeText: boolean): string {
  return isFreeText ? texto : reconstructCertificateReasonFromText(texto);
}
